//TODO: remove this file once Button.jsx is improved by end of ina-171

/**
 * @fileOverview File with Button component
 * @description File containing RegularButton function
 * @author Ehasan Rashdul
 * @author Komal Chevli
 * @since 1.0.0
 */

import React from "react";

// nodejs library to set properties for components
import PropTypes from "prop-types";

/**
 * The only true button.
 */
class RegularButton extends React.Component {
  constructor(props) {
    super(props);

    const {
      className
    } = props;

    this.state = {
      className: className
    }
  }

  render() {
    return (<input
      type="submit"
      id={this.props.id}
      value={this.props.id}
      className={this.props.className}></input>);
  }
}

RegularButton.propTypes = {
  /** Button label */
  classes: PropTypes.object.isRequired,
  /** The color for the button */
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "transparent"
  ]),
  /** The size of the button */
  size: PropTypes.oneOf(["sm", "lg"]),
  /** Simple button */
  simple: PropTypes.bool,
  /** Round button */
  round: PropTypes.bool,
  /** Disable button */
  disabled: PropTypes.bool,
  /** Block button */
  block: PropTypes.bool,
  /** Link button*/
  link: PropTypes.bool,
  /** Icon button */
  justIcon: PropTypes.bool,

  className: PropTypes.string
};

export default (RegularButton);
